<template>
    <div class="electricity">
        <Title :firstName="this.type" lastName="ELECTRICITY STATISTICS" :showIcon="true" @changeTitle="changeTitle"/>
        <div class="echarts">
            <div class="edata">
                <div class="edataCon" v-show="type == '用电统计'">
                    <p>本月总电量</p>
                    <p>{{monthTotal}}<span> kWh</span></p>
                </div>
                <div class="edataCon" v-show="type == '发电统计'">
                    <p>本月发电量</p>
                    <p>{{fadianTotal.sumFadian}}<span> kWh</span></p>
                </div>
                <div class="edataCon" v-show="type == '储能统计'">
                    <p>本月储电量</p>
                    <p>{{fadianTotal.sumChu}}<span> kWh</span></p>
                </div>
                <div :class="$store.state.electricityFlag? 'fenbu':'fenbu col'" @click="showElectricity()" v-show="type == '用电统计'">
                    <img src="../../assets/img/nor_fenbu.png" alt="" v-show="$store.state.electricityFlag"> 
                    <img src="../../assets/img/sel_fenbu.png" alt="" v-show="!$store.state.electricityFlag"> 分布
                </div>
                <!-- <div class="sevenDay" v-show="type == '用电统计'">近七日用电</div>
                <div class="sevenDay" v-show="type == '发电统计'">近七日发电</div>
                <div class="sevenDay" v-show="type == '储能统计'">近七日储电</div> -->
            </div>
            <div class="eview">
                <Bar :chartId="chartId" :seriesData="seriesData" :xData="xData" unit="kWh" v-if="seriesData.length > 0"/>
            </div>
            <div class="bottom"></div>
        </div>
        <div class="list" v-show="showList">
            <SelectList :selectList="typeList" @tabTitle="tabTitle" keyk="id" keyval="value" />
        </div>
    </div>
</template>

<script>
const Title = () => import('../../components/title/Title')
const SelectList = () => import('../../components/title/selectList.vue')
const Bar = () => import('../../components/echarts/bar.vue')
import { getMonthTime, getSevenDays } from '../../utils/common'

export default {
    data(){
        return {
            type:'用电统计',
            monthTotal:'',
            showList:false,
            chartId:'electricity',
            xData:['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            seriesData:[],
            allSeries:[],
            typeList:[
                {
                    id:1,
                    value:'用电统计'
                },
                {
                    id:2,
                    value:'发电统计'
                },
                {
                    id:3,
                    value:'储能统计'
                },
            ],

            fadian:[0, 0, 0, 860, 432, 430, 200],
            chuneng:[0, 0, 0, 160, 160, 160, 160]
        }
    },
    components:{
        Title,
        SelectList,
        Bar
    },
    computed:{
        fadianTotal(){
            let sumFadian = 0
            let sumChu = 0
            let sum = 0
            this.fadian.forEach(item =>{
                sumFadian += item
            })
            this.chuneng.forEach(item =>{
                sumChu += item
            })
            this.seriesData.forEach(item =>{
                sum += item
            })

            return {sumFadian, sumChu, sum}
        }
    },
    created(){
        this.$store.commit('set_electricityFlag',true)
        this.getTotalElectricity()
        this.getProjectWeek()
    },
    mounted(){

    },
    methods:{
        changeTitle(){
            this.showList = !this.showList
        },
        tabTitle(title){
            console.log(title);
            this.type = title.value
            this.showList = false
            this.seriesData = this.allSeries[title.id - 1]
        },
        showElectricity(){
            this.$store.commit('set_electricityFlag',!this.$store.state.electricityFlag)
            this.$emit('showElectricity',this.$store.state.electricityFlag)
        },
        // 获取当月的项目总用电 
        async getTotalElectricity(){
            let time = getMonthTime()
            // console.log(time);
            let data = {
                projectId:this.$store.state.projectId,
                start:`${time.start}T00:00:00Z`,
                end:`${time.end}T00:00:00Z`
            }
            let res = await this.$http.PowerAreasAnalysis(data)
            console.log(res);

            let total = res.data.data.result.find(item => item['总'])

            this.monthTotal = total['总'].total? (total['总'].total ).toFixed(2) : 0
            
            
        },
        // 和7天内的用电 量
        async getProjectWeek(){
            let time1 =  getSevenDays()
            let timeArr = Object.values(time1)
            // console.log(timeArr);

            let weekTime = []
            for(let i = 0;i <timeArr.length;i++){
                weekTime.unshift(timeArr[i].substr(5))
            }
            this.xData = weekTime
            // let obj = total['总'][`year_${time.start.substr(0,4)}`][`month_${time.start.substr(6,1)}`]

            // let arr = []
            // weekTime.forEach(item =>{
            //     let day = item.substr(item.length - 2, 1) == '0' ? item.substr(item.length - 1, 1) :item.substr(item.length - 2, 2) 
            //     // console.log(day);
            //     arr.push(obj[`day_${day}`]?obj[`day_${day}`].daySum / 1000 :0)
            // })
            // // console.log(arr);
            // this.seriesData = arr
            let arr = []
            for(let i = 0;i<timeArr.length;i++){
                let data = {
                    projectId:this.$store.state.projectId,
                    start:`${timeArr[i]}T00:00:00Z`,
                    end:`${timeArr[i]}T24:00:00Z`,
                }
                let res = await this.$http.diagramDay(data)
                arr.unshift(res.data.data.data[0])
            }
            this.seriesData = arr

            this.$set(this.allSeries,0,arr)
            
            this.$set(this.allSeries,2,[160, 160, 160, 160, 160, 160, 160])
            this.getWeekElectricity()
        },
        async getWeekElectricity(){
            let sevenDays = getSevenDays()
            console.log(sevenDays);

            let keys = Object.values(sevenDays)
            // console.log(keys);

            let days = []
            for(let i = 0;i <keys.length;i++){
                days.unshift(keys[i].substr(5))
            }

            this.xData = days

            let data = {
                start : `${sevenDays.seven}T00:00:00Z`,
                end : `${sevenDays.one}T24:00:00Z`,
                projectId:this.$store.state.projectId
            }
            let res = await this.$http.getdailyPowerInverter(data)
            console.log(res);
            let arr = res.data.data.points.map(item => item = Number(item).toFixed(2))
            this.$set(this.allSeries,1,arr)
        }
        
    }
}
</script>

<style lang="less" scoped>
    
    .electricity{
        height: 33.3vh;
        width: 20vw;
        position: fixed;
        top: 7.4vh;
        right: 1vw;

        .echarts{
            position: relative;
            height: 25vh;
            padding-bottom: 1vh;
            background:  linear-gradient(0deg, rgba(0, 33, 59, 0.6) 0%, rgba(3, 13, 24, 0.7) 100%);

            .edata{
                display: flex;
                justify-content: space-around;
                padding: 2.5vh 0 1vh 0;
                position: relative;
                .edataCon{
                    text-align: center;
                    p:nth-child(1){
                        font-size: 14rem;
                        font-family: Source Han Sans CN;
                        font-weight: 400;
                        color: rgba(230,243,253, 0.7);
                    }
                    p:nth-child(2){
                        padding-top: 3rem;
                        font-size: 20rem;
                        font-family: zcoolqingkehuangyouti;
                        font-weight: 400;
                        color: #00DEFF;
                        span{
                            font-size: 14rem;
                        }
                    }
                }
                .fenbu{
                    position: absolute;
                    right: 1vw;
                    top: 1vh;
                    width: 88rem;
                    height: 30rem;
                    line-height: 30rem;
                    text-align: center;
                    border-radius: 2rem;
                    color: rgba(230,243,253, 0.7);
                    font-family: Source Han Sans CN;
                    font-weight: 400;
                    background: url('../../assets/img/dwbgw.png');
                    background-size: 100% 100%;
                    cursor: pointer;
                    img{
                        width: 18rem;
                        height: 14rem;
                        vertical-align: -2rem;
                    }
                }
                .col{
                    color: #0d94ff;
                    background: url('../../assets/img/dwbj.png');
                    background-size: 100% 100%;

                }
                
                .sevenDay{
                    font-size: 12rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(230,243,253, 0.7);
                    position: absolute;
                    right: 1vw;
                    top: 6.5vh;
                }
            }

            .eview{
                width: 100%;
                padding: 0 0.5vw;
                height: 16.5vh;
                #electCharts{
                    width: 100%;
                    height: 100%;
                }
            }

            .bottom{
                width: 20vw;
                height: 1vh;
                background: url(../../assets/img/板块装饰线.png) no-repeat;
                block-size: 100% 100%;
                position: absolute;
                bottom: 0;
                left: 0;
            }
        }

        .list{
            height: 10.5vh;
            width: 100%;
            position: absolute;
            left: 0;
            top: 5vh;
            z-index: 11;
        }
        
    }

</style>